import { createFileRoute, useNavigate } from "@tanstack/react-router";
import {
  BackButton,
  Footer,
  Header,
  Page,
  PageContent,
} from "@/components/page.tsx";
import { Trans, useTranslation } from "react-i18next";
import { z } from "zod";
import { useAudioSlot } from "@/features/audio/kiosk-audio";
import { DryerBundleChoice } from "@/features/dryer-bundles/dryer-bundle-choice";
import { MachineSelectHelpText } from "./machine-selector-screen.$machine-type";

export const Route = createFileRoute(
  "/dryer-bundle-selector-screen/$machineId",
)({
  component: RouteComponent,
  params: {
    parse: (params) =>
      z
        .object({
          machineId: z.coerce.number(),
        })
        .parse(params),
  },
});

function RouteComponent() {
  useAudioSlot("page.dryer-bundle-selector");
  const { t } = useTranslation();
  const { machineId } = Route.useParams();
  const navigate = useNavigate();

  return (
    <Page>
      <Header
        backArrowHref={
          <BackButton
            label={t("Vissza")}
            onClick={() => {
              navigate({
                to: "/machine-selector-screen/$machine-type",
                params: { "machine-type": `drying-machines` },
              });
            }}
          />
        }
      />
      <PageContent className={`px-0 max-w-full`}>
        <h2 className={`font-helvetica font-bold text-6xl text-center mb-8`}>
          <Trans>Válaszd ki a szárítás idejét!</Trans>
        </h2>
        <DryerBundleChoice
          machineId={machineId}
          onSelect={(bundle) =>
            navigate({
              to: "/payment-selector-screen/$machineId/{-$dryerBundleId}",
              params: { machineId, dryerBundleId: bundle.id },
            })
          }
        />
        <Footer helpText={<MachineSelectHelpText />} />
      </PageContent>
    </Page>
  );
}
